import Section from "./Section";
import { Droppable } from "@hello-pangea/dnd";

const SectionsContainer = ({
  sections,
  onEditSection,
  onDeleteSection,
  onEditInput,
  onDeleteInput,
  setSectionNameModal,
  disabled = false,
}) => {
  return (
    <>
      {sections?.length > 0 && (
        <Droppable droppableId="SECTIONS" type="SECTION">
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className={`flex flex-col gap-4 ${disabled && "pointer-events-none"}`}
            >
              {sections.map((section, index) => (
                <Section
                  key={section.sectionId}
                  section={section}
                  index={index}
                  onEditSection={onEditSection}
                  onDeleteSection={onDeleteSection}
                  onEditInput={onEditInput}
                  onDeleteInput={onDeleteInput}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      )}

      {/* <div
        onClick={() => {
          if (!disabled) {
            setSectionNameModal(true);
          }
        }}
        className={`flex justify-center ${disabled && "pointer-events-none"} border-2 min-h-[100px] group items-center border-dashed border-[#D2DAE1] cursor-pointer rounded-md mt-4`}
      >
        <p className="text-primary group-hover:opacity-70">+ Add Section</p>
      </div> */}
    </>
  );
};

export default SectionsContainer;
